import { clearServiceWorkerState } from "./registerServiceWorker";

const CHUNK_RECOVERY_FLAG = "clover:chunk-recovery-attempted";

function isJavaScriptChunkUrl(url: string): boolean {
  return /\/js\/.+\.js(?:\?.*)?$/i.test(url);
}

function isChunkLoadMessage(message: string): boolean {
  return /chunkloaderror|loading chunk [^ ]+ failed|loading css chunk [^ ]+ failed/i.test(
    message,
  );
}

function isChunkErrorEvent(event: Event): boolean {
  const target = event.target;
  if (target instanceof HTMLScriptElement) {
    return isJavaScriptChunkUrl(target.src);
  }

  if (event instanceof ErrorEvent) {
    return (
      isJavaScriptChunkUrl(event.filename) && /unexpected token/i.test(event.message)
    );
  }

  return false;
}

function hasAttemptedRecovery(): boolean {
  return sessionStorage.getItem(CHUNK_RECOVERY_FLAG) === "1";
}

async function recoverFromChunkLoadFailure(): Promise<void> {
  if (hasAttemptedRecovery()) {
    return;
  }

  sessionStorage.setItem(CHUNK_RECOVERY_FLAG, "1");
  await clearServiceWorkerState();
  window.location.reload();
}

export function installChunkLoadRecovery(): void {
  window.addEventListener(
    "load",
    () => {
      sessionStorage.removeItem(CHUNK_RECOVERY_FLAG);
    },
    { once: true },
  );

  window.addEventListener(
    "error",
    (event) => {
      if (isChunkErrorEvent(event)) {
        void recoverFromChunkLoadFailure();
      }
    },
    true,
  );

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    if (
      reason instanceof Error &&
      isChunkLoadMessage(`${reason.name} ${reason.message}`)
    ) {
      void recoverFromChunkLoadFailure();
    }
  });
}
